"use client";
import React, { createContext } from "react";

interface TourData {
  tourID?: string;
  tourStep?: number;
}

interface TourContextType {
  tour: TourData | null;
  handleUpdateTour: (tourValue: TourData) => void;
  handleSideBar: () => void;
}

interface Props {
  children: React.ReactNode;
  handleOpenSideBar: () => void;
  tourInputData: TourData;
}

export const TourContext = createContext<TourContextType | null>(null);

export const TourProvider: React.FC<Props> = ({
  children,
  handleOpenSideBar,
  tourInputData,
}) => {
  const [tour, setTour] = React.useState<TourData | null>(
    tourInputData || null
  );

  React.useEffect(() => {
    if (tourInputData) {
      setTour(tourInputData);
    }
  }, [tourInputData]);

  const handleUpdateTour = (inputValue: TourData) => {
    setTour(inputValue);
  };

  const handleOpenSideBarContext = () => {
    handleOpenSideBar();
  };
  return (
    <TourContext.Provider
      value={{
        handleUpdateTour,
        tour,
        handleSideBar: handleOpenSideBarContext,
      }}
    >
      {children}
    </TourContext.Provider>
  );
};

export default TourProvider;
